const isDefined = value => value !== undefined;
const isValidNumber = value => typeof value === "number" && !isNaN(value);

const throwError = message => {
  throw new Error(message);
};

export function validateRange({ min, max }) {
  try {
    if (isDefined(min) && isDefined(max)) {
      if (!isValidNumber(min)) throwError("min must be a valid number");
      if (!isValidNumber(max)) throwError("max must be a valid number");
      if (min >= max) throwError("min must be less than max");
      return true; // valid case
    }

    if (isDefined(min)) {
      if (!isValidNumber(min)) throwError("min must be a valid number");
      return true;
    }

    if (isDefined(max)) {
      if (!isValidNumber(max)) throwError("max must be a valid number");
      return true;
    }

    throwError('At least one of "min" or "max" must be provided');
  } catch (error) {
    return false;
  }
}
